import React from "react";

function GridActions({ orderDirection, setOrderDirection, sortBy, setSortBy }) {
  return (
    <div className="flex justify-between md:gap-32px gap-20px items-center mt-20px sm:flex-row flex-col">
      <div className="flex sm:max-w-[320px] w-full bg-white dark:bg-accent-800 text-sm rounded-lg border border-primary-100 dark:border-none overflow-hidden max-h-[40px] focus-within:outline focus-within:outline-primary-500 outline-2">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_235_12502"
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="24"
          >
            <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_235_12502)">
            <path
              d="M27.6 29L21.3 22.7C20.8 23.1 20.225 23.4167 19.575 23.65C18.925 23.8833 18.2333 24 17.5 24C15.6833 24 14.1458 23.3708 12.8875 22.1125C11.6292 20.8542 11 19.3167 11 17.5C11 15.6833 11.6292 14.1458 12.8875 12.8875C14.1458 11.6292 15.6833 11 17.5 11C19.3167 11 20.8542 11.6292 22.1125 12.8875C23.3708 14.1458 24 15.6833 24 17.5C24 18.2333 23.8833 18.925 23.65 19.575C23.4167 20.225 23.1 20.8 22.7 21.3L29 27.6L27.6 29ZM17.5 22C18.75 22 19.8125 21.5625 20.6875 20.6875C21.5625 19.8125 22 18.75 22 17.5C22 16.25 21.5625 15.1875 20.6875 14.3125C19.8125 13.4375 18.75 13 17.5 13C16.25 13 15.1875 13.4375 14.3125 14.3125C13.4375 15.1875 13 16.25 13 17.5C13 18.75 13.4375 19.8125 14.3125 20.6875C15.1875 21.5625 16.25 22 17.5 22Z"
              fill="#8388A0"
            />
          </g>
        </svg>

        <input
          className="w-full ps-16px outline-none font-medium text-primary-900 dark:text-accent-100 bg-transparent"
          type="text"
          placeholder="Search for links"
        />
      </div>
      <div className="text-sm flex gap-16px select-none items-center sm:w-auto w-full justify-center">
        <button
          type="button"
          className="sm:whitespace-nowrap h-fit max-h-[40px] sm:w-auto w-fit justify-center bg-white dark:bg-accent-800 py-2 px-10px border border-primary-100 dark:border-none text-accent-400 rounded-lg flex items-center gap-3 text-sm outline-none"
          onClick={() =>
            setOrderDirection(orderDirection === "asc" ? "desc" : "asc")
          }
        >
          <div className="flex w-[18px] items-center">
            <svg
              className="w-full"
              width="22"
              height="22"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_460_2268"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="25"
                height="25"
              >
                <rect
                  x="0.817505"
                  y="24.6467"
                  width="24"
                  height="24"
                  transform="rotate(-90 0.817505 24.6467)"
                  fill="#D9D9D9"
                />
              </mask>
              <g mask="url(#mask0_460_2268)">
                <path
                  d="M21.8175 17.6467L16.8175 22.6467L11.8175 17.6467L13.2175 16.2217L15.8175 18.8217L15.8175 3.64673H17.8175V18.8217L20.4175 16.2217L21.8175 17.6467ZM13.8175 7.64673L12.4175 9.07173L9.8175 6.47173V21.6467H7.8175L7.8175 6.47173L5.2175 9.07173L3.8175 7.64673L8.8175 2.64673L13.8175 7.64673Z"
                  className="fill-accent-400 dark:fill-accent-300"
                />
              </g>
            </svg>
          </div>
        </button>
        <div className="sm:w-auto w-fit justify-center sm:whitespace-nowrap h-fit max-h-[40px] bg-white dark:bg-accent-800 py-2 px-10px border border-primary-100 dark:border-none text-accent-400 dark:text-accent-300 flex items-center gap-3 text-sm outline-none rounded-lg">
          <div className=" flex w-[18px] items-center">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_460_2256"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="25"
                height="25"
              >
                <rect
                  x="0.817505"
                  y="0.646729"
                  width="24"
                  height="24"
                  fill="#D9D9D9"
                />
              </mask>
              <g mask="url(#mask0_460_2256)">
                <path
                  d="M3.8175 18.6467V16.6467H9.8175V18.6467H3.8175ZM3.8175 13.6467V11.6467H15.8175V13.6467H3.8175ZM3.8175 8.64673V6.64673H21.8175V8.64673H3.8175Z"
                  className="fill-accent-400 dark:fill-accent-300"
                />
              </g>
            </svg>
          </div>
          Sort by{" "}
          <select
            className="bg-transparent outline-none text-sm"
            name=""
            id=""
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="date">Date</option>
            <option value="clicks">Clicks</option>
            <option value="title">Title</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default GridActions;
